import "./Logo.css";

export default function Logo() {
  return (
    <div className="logo-container">
      <img src="/assets/images/aboutus.png" alt="Logo" className="about-us" />
    </div>
  );
}
